"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var development_1 = __importDefault(require("./development"));
var us_1 = __importDefault(require("./us"));
var eu_1 = __importDefault(require("./eu"));
var qa_1 = __importDefault(require("./qa"));
var environment_1 = require("shared/utils/environment");
var localConfigs = {
  QA: qa_1.default,
  EU: eu_1.default,
  US: us_1.default
};
exports.default = Object.assign(Object.assign(Object.assign({}, environment_1.isBrowser && window.DRIFT_CONFIG || {}), localConfigs[environment_1.isBrowser && window.DRIFT_REGION || (environment_1.isProduction ? 'US' : 'QA')]), environment_1.isDev && development_1.default || {});